import React, { useState } from "react";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";
import Tabble from "./tabble";
import { Indicators, SelectO } from "../../components";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const rowsPerPageOptions = [
    { value: 5, label: "05" },
    { value: 10, label: "10" },
    { value: 15, label: "15" },
];

const TableBlk = ({
    headerIcon,
    heading,
    subHeading,
    thrside,
    data = [],
    columns,
    tabbleClassname,
    tabbleSectionClassname,
    noDataMessage,
}) => {
    const { t } = useTranslation();
    const loading = useSelector((state) => state.loader.loading);
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0].value);
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentData = data?.slice(startIndex, startIndex + rowsPerPage);

    const handleRowsPerPageChange = (selectedOption) => {
        setRowsPerPage(selectedOption.value);
        setCurrentPage(1);
    };

    const handlePageChange = (direction) => {
        if (direction === "next" && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        } else if (direction === "prev" && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const totalPages = Math.ceil(data?.length / rowsPerPage);

    return (
        <>
            <section className={`table-blk ${tabbleSectionClassname}`}>
                <div className="table-header">
                    <aside className="table-header-lside">
                        <div className="table-header-iconBlk">{headerIcon}</div>
                        <div>
                            <h5 className="exado-title-seven">{heading}</h5>
                            <p>{subHeading}</p>
                        </div>
                    </aside>
                    <aside className="table-header-rside">{thrside}</aside>
                </div>

                {data.length > 0 ? (
                    <>
                        <Tabble
                            data={currentData}
                            columns={columns}
                            className={tabbleClassname}
                        />

                    </>
                ) : (
                    <div className="no-data-message">{noDataMessage}</div>
                )}

                <div className="table-footer">
                    {data.length > 0 ? (
                        <>
                            <aside className="table-footer-lside">
                                <label htmlFor="" className="table-footer-lside-lable">
                                    {t("rows_per_page")}
                                </label>
                                <SelectO.SelectO
                                    options={rowsPerPageOptions}
                                    className="select2"
                                    isSearchable={false}
                                    defaultValue={rowsPerPageOptions[0]}
                                    onChange={handleRowsPerPageChange}
                                    components={{ DropdownIndicator: Indicators.DropDownIndicator }}
                                />
                            </aside>
                            <aside className="table-footer-rside">
                                <label htmlFor="" className="table-footer-rside-lable">
                                    {t("Page")} {currentPage} {t("of")} {totalPages}
                                </label>
                                <div className="Page-icon-blk">
                                    <FaCaretLeft
                                        className="Page-icon-left"
                                        onClick={() => handlePageChange("prev")}
                                    />
                                    <FaCaretRight
                                        className="Page-icon-right"
                                        onClick={() => handlePageChange("next")}
                                    />
                                </div>
                            </aside>
                        </>

                    ) : ("")}
                </div>
            </section>
        </>
    );
};

export default TableBlk;
